import React from "react";
import { beritaData } from "../../data/beritaData";
import { Link } from "react-router-dom";
const Berita = () => {
  const truncateMultiline = (lines) => {
    return {
      display: "-webkit-box",
      WebkitBoxOrient: "vertical",
      WebkitLineClamp: lines,
      overflow: "hidden",
    };
  };

  return (
    <>
      <header className="relative w-full h-screen overflow-hidden">
        {/* Background Image */}
        <img
          src="/images/asset/header-berita.svg"
          alt="Background"
          className="absolute inset-0 w-full h-full object-cover object-top z-0"
        />

        {/* Konten Wrapper: flex kiri-kanan dengan stack di mobile */}
        <div className="relative z-20 flex flex-col md:flex-row items-center justify-between h-full px-6 py-12 md:px-16 lg:px-24 text-white max-w-[1440px] mx-auto">
          {/* Teks kiri */}
          <div className="w-full md:w-1/2 flex flex-col items-center md:items-start text-center md:text-left space-y-4 md:space-y-6 max-w-lg">
            <p className="font-pontano text-sm md:text-base tracking-wider opacity-90 font-inter">
              Berita
            </p>
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-semibold leading-tight drop-shadow-md font-pontano">
              Dana Pensiun <br />
              Toyota Astra
            </h1>
            <button
              onClick={() =>
                document
                  .getElementById("berita-terbaru")
                  ?.scrollIntoView({ behavior: "smooth" })
              }
              className="mt-4 md:mt-6 bg-[#EF1C22] hover:bg-red-700 transition px-6 py-3 rounded-md text-sm md:text-base font-medium shadow-lg font-inter"
            >
              Lihat Berita Terbaru
            </button>
          </div>

          {/* Gambar sound bawah teks di mobile, kanan di desktop */}
          <div className="w-full md:w-1/2 mb-8 md:mb-0 flex justify-center md:justify-end max-w-[500px]">
            <img
              src="/images/asset/sound.svg"
              alt="Sound Illustration"
              className="w-full h-auto object-contain"
            />
          </div>
        </div>
      </header>

      <section
        id="berita-terbaru"
        className="px-4 sm:px-6 lg:px-16 xl:px-24 py-10"
      >
        <h2 className="text-base font-bold text-gray-800 mb-6 font-pontano">
          Berita Terbaru
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {beritaData.map((item) => (
            <div
              key={item.id}
              className="hover:shadow-md transition-all duration-300 flex flex-col"
            >
              <img
                src={item.image}
                alt={item.title}
                className="w-full h-[220px] md:h-[260px] lg:h-[280px] xl:h-[300px] object-cover"
              />
              <div className="p-4 flex flex-col flex-1">
                <h3
                  className="text-base font-bold text-gray-900 mb-2 leading-snug font-pontano"
                  style={truncateMultiline(2)}
                >
                  {item.title}
                </h3>
                <p
                  className="text-sm text-gray-600 mb-4 font-inter"
                  style={truncateMultiline(3)}
                >
                  {item.summary}
                </p>
                <div className="mt-auto flex justify-center">
                  <Link
                    to={`/berita/${item.id}`}
                    className="text-[#EB0A1E] text-sm font-bold inline-flex items-center gap-1 hover:underline"
                  >
                    Selengkapnya{" "}
                    <img
                      src="/images/asset/arrow.svg"
                      alt="arrow"
                      className="w-4 h-4 object-contain"
                    />
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default Berita;
